import script from "./EditAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./EditAnnouncement.vue?vue&type=style&index=0&id=3f294ce5&lang=css"

const __exports__ = script;

export default __exports__